<script lang="typescript">
import { onMount, onDestroy, tick, createEventDispatcher, beforeUpdate } from 'svelte';
import { fade, slide } from 'svelte/transition';
import type { Research } from '../models/Research';
import { ResearchDisplaySettiings } from '../models/ResearchModels/ResearchDisplaySettings';
// import TextArea from "./textareaAutosize.svelte";
import { text_area_resize } from '../common/text_area_resize'

export let research: Research;
export let readOnlyMode: boolean;

const dispatch = createEventDispatcher();
function saveResearch(research) {
    dispatch('saveprop', {
        prop: 'research'
    });
}

let recentlyChecked = ''

var researchEditor;
let duration = 400;

beforeUpdate(()=>{
if(research.displaySettings == null){
    research.displaySettings = new ResearchDisplaySettiings();
    Object.assign(research, {displaySettings: new ResearchDisplaySettiings()})
}
})

onMount(()=>{
    if(research.displaySettings == null){
        research.displaySettings = new ResearchDisplaySettiings();
        Object.assign(research, {displaySettings: new ResearchDisplaySettiings()})
    }
})

onDestroy(()=>{
    duration = 0;
})

$: {
    if (research?.curiosityCorruption?.outsideForcesBeliefBoolean || research?.curiosityCorruption?.olderAttemptsBoolean){
        tick().then(()=>{
            const researchContainer = document.getElementById("researchContainer");
            const target = document.getElementById(recentlyChecked)
            researchContainer.scrollTop = researchContainer.scrollTop - 100
            if(target != null){
                target.scrollIntoView({behavior: 'smooth'});
            }
        })
    }
}
$:saveResearch(research)

async function scrollIfCheckingTrue(checkbox: Event & {
    currentTarget: EventTarget & HTMLInputElement
}, viewTarget: string
){
    console.log(`Checkbox: ${checkbox.currentTarget.checked}`)
    if(checkbox.currentTarget.checked){
        window.scrollBy({top: window.scrollY + 50, behavior: 'smooth'})
        document.getElementById(viewTarget).scrollIntoView();
    }
}
let researchContainerDiv : HTMLElement;
let copied = false;
function copyFormattedLetter () {
  const copyContents = researchContainerDiv.innerHTML;
  var container = document.createElement('div');
  container.innerHTML = copyContents;
  container.style.position = 'fixed'
  container.style.pointerEvents = 'none'
  var activeSheets = Array.prototype.slice.call(document.styleSheets)
    .filter(function (sheet) {
      return !sheet.disabled
    })
  document.body.appendChild(container)
  window.getSelection().removeAllRanges()
  var range = document.createRange()
  range.selectNode(container)
  window.getSelection().addRange(range)
  document.execCommand('copy')
  for (var i = 0; i < activeSheets.length; i++) activeSheets[i].disabled = true
  document.execCommand('copy')
  for (var i = 0; i < activeSheets.length; i++) activeSheets[i].disabled = false
  document.body.removeChild(container)
  copied = true;
  setTimeout(()=>{
      copied = false;
  }, 2500)
}
</script>

<div
bind:this={researchContainerDiv}
in:fade={{delay:400, duration:400}} out:fade={{duration: 400}} class="editingContainer" id="researchContainer">
    <!-- <div class="editorContainer">      
        <div class="editor {currentTab === 1 ? 'activeEditor' : 'inactiveEditor'}" id="researchEditor"></div>
    </div> -->
    <div class="editorContainer activeEditor editor pl-2">   
    <form class='briefForm grid pb-4 pl-4'>
        <h1
        on:click={(evt)=> {
            evt.preventDefault()
            research.displaySettings.showDemographics = !research.displaySettings.showDemographics}}
         class="researchSectionHeading">Demographic Insights: 
            <button class="
            accordionButton 
            {research.displaySettings.showDemographics?"bg-red-500" : "bg-third"}">
            {#if research.displaySettings.showDemographics} - {:else} + {/if}</button>
        </h1>
        {#if research.displaySettings.showDemographics}
        <div transition:slide|local class="demographicDiv">
            <div>
                <label for="customer">Who is your customer? How old are they, typically?</label>
                <textarea disabled={readOnlyMode} bind:value={research.demographicInsights.customer} autocomplete="off"  class="shortBriefInput" type="text" name="customer" id="customer"
                use:text_area_resize/>
            </div>

            <div class="textAreaDiv">
                <label for="attitudes">What attitudes do they have? (Religious, Political, Social, Economic)</label>
                <textarea disabled={readOnlyMode} bind:value={research.demographicInsights.attitudes} class="shortBriefInput" rows="5" name="attitudes" id="attitudes"
                use:text_area_resize
                />
            </div>

            <div class="textAreaDiv">
                <label for="hopesAndDreams">What Are Their Hopes and Dreams?</label>
                <textarea disabled={readOnlyMode} bind:value={research.demographicInsights.hopesAndDreams} class="shortBriefInput" rows="3" name="hopesAndDreams" id="hopesAndDreams"
                use:text_area_resize
                />
            </div>

            <div class="textAreaDiv">
                <label for="victoriesAndFailures"><strong>What are their victories and failures?</strong></label>
                <p>Victories:</p>
                <textarea disabled={readOnlyMode} bind:value={research.demographicInsights.victoriesAndFailures} class="shortBriefInput" rows="3" name="victoriesAndFailures" id="victoriesAndFailures"
                use:text_area_resize
                />
                <p>Failures:</p>
                <textarea disabled={readOnlyMode} bind:value={research.demographicInsights.failures} class="shortBriefInput" rows="3" name="failures" id="failures"
                use:text_area_resize
                />
            </div>
            <div class="textAreaDiv">
                <label for="outsideForces">What outside forces do they believe have prevented their best life?</label>
                <textarea disabled={readOnlyMode} bind:value={research.demographicInsights.outsideForces} class="shortBriefInput" rows="3" name="outsideForces" id="outsideForces"
                use:text_area_resize
                />
            </div>

            <div class="textAreaDiv">
                <label for="prejudices">What are their prejudices?</label>
                <textarea disabled={readOnlyMode} bind:value={research.demographicInsights.prejudices} rows="3" class="shortBriefInput" name="prejudices" id="prejudices"
                use:text_area_resize
                />
            </div>

            <div class="textAreaDiv">
                <label for="coreBeliefs">Are you able to sum up their core beliefs about life, love, and family in 1-3 sentences?</label>
                <textarea disabled={readOnlyMode} rows="3" bind:value={research.demographicInsights.coreBeliefs} class="shortBriefInput" name="coreBeliefs" id="coreBeliefs"
                use:text_area_resize
                />
            </div>
        </div>
        {/if}
        <h1
        on:click={(evt)=> {
            evt.preventDefault()
            research.displaySettings.showExistingSolutions = !research.displaySettings.showExistingSolutions}}
         class="researchSectionHeading">Other Existing Solutions: 
            <button class="accordionButton 
            {research.displaySettings.showExistingSolutions?"bg-red-500" : "bg-third"} ">
            {#if research.displaySettings.showExistingSolutions
                } - {:else} + {/if}</button>
        </h1>
        {#if research.displaySettings.showExistingSolutions}
        <div transition:slide|local class="existingSolutionsDiv">

        <div class="textAreaDiv">
            <label for="marketUsing">What is the market already using? (List these out)</label>
            <textarea disabled={readOnlyMode}  bind:value={research.existingSolutions.marketUsing} rows="3" class="shortBriefInput" name="marketUsing" id="marketUsing"
            use:text_area_resize
            />
        </div>

        <div class="textAreaDiv">
            <label for="existingExperience">What has their experience been like?</label>
            <textarea disabled={readOnlyMode}  bind:value={research.existingSolutions.existingExperience} rows="5" class="shortBriefInput" name="existingExperience" id="existingExperience"
            use:text_area_resize
            />
        </div>

        <div class="textAreaDiv">
            <label for="existingLikes">What does the market like about existing solutions?</label>
            <textarea disabled={readOnlyMode} bind:value={research.existingSolutions.existingLikes} rows="5" class="shortBriefInput" name="existingLikes" id="existingLikes"
            use:text_area_resize
            />
        </div>

        <div class="textAreaDiv">
            <label for="existingDislikes">What does the market dislike about existing solutions?</label>
            <textarea disabled={readOnlyMode} bind:value={research.existingSolutions.existingDislikes} rows="5" class="shortBriefInput" name="existingDislikes" id="existingDislikes"
            use:text_area_resize
            />
        </div>
        <div class="textAreaDiv">
            <label for="horrorStories">Are there horror stories about existing solutions?</label>
            <textarea disabled={readOnlyMode} bind:value={research.existingSolutions.horrorStories} rows="3" class="shortBriefInput" name="horrorStories" id="horrorStories"
            use:text_area_resize
            />
        </div>
        <div class="textAreaDiv">
            <label for="existingSolutionsWork">Does the market believe existing solutions work? If not, why not?</label>
            <textarea disabled={readOnlyMode}  bind:value={research.existingSolutions.existingSolutionsWork} rows="3" class="shortBriefInput" name="existingSolutionsWork" id="existingSolutionsWork"
            use:text_area_resize
            />
        </div>
    </div>
    {/if}
    <h1
    on:click={(evt)=> {
        evt.preventDefault()
        research.displaySettings.showCuriosity = !research.displaySettings.showCuriosity}}
        class="researchSectionHeading">Curiosity & Corruption: 
        <button class="
        accordionButton 
        {research.displaySettings.showCuriosity?"bg-red-500" : "bg-third"}">
        {#if research.displaySettings.showCuriosity
            } - {:else} + {/if}</button>
    </h1>
    {#if research.displaySettings.showCuriosity}
    <div transition:slide|local class="curiosityDiv">
        <div class="textAreaDiv">
            <label for="uniqueSolutionAttempts">Has someone tried to solve the market’s pain points before in a very unique way? (List out these attempts)</label>
            <textarea disabled={readOnlyMode} bind:value={research.curiosityCorruption.uniqueSolutionAttempts} rows="5" class="shortBriefInput" name="uniqueSolutionAttempts" id="uniqueSolutionAttempts"
            use:text_area_resize
            />
            
            <label for="attemptResults">What was the result of these attempts?</label>
            <textarea disabled={readOnlyMode} bind:value={research.curiosityCorruption.attemptResults} rows="5" class="shortBriefInput" name="attemptResults" id="attemptResults"
            use:text_area_resize
            />

            <label for="conspiracyStory">Is there a conspiratorial story behind why old solutions didn’t work?</label>
            <textarea disabled={readOnlyMode} bind:value={research.curiosityCorruption.conspiracyStory} rows="3" class="shortBriefInput" name="conspiracyStory" id="conspiracyStory"
            use:text_area_resize
            />

            <label for="olderAttempts">Are there any older attempts to solve the problem (Pre-1960) that are unique?</label>
            <input name="olderAttemptsBoolean" 
            class="w-6 h-6 pl-6 ring-2 ring-offset-blue-400" 
            on:click={() => recentlyChecked = 'olderAttempts'}
            bind:checked={research.curiosityCorruption.olderAttemptsBoolean}
            type="checkbox" /><span class="h-6 pl-3" style="vertical-align:super;">Yes.</span>
            {#if research.curiosityCorruption.olderAttemptsBoolean}
            <div class="textAreaDiv" transition:slide|local>
                <p class="h-6 pl-3" style="vertical-align:super;">List these out.</p>
                <textarea disabled={readOnlyMode} bind:value={research.curiosityCorruption.olderAttempts} rows="3" class="shortBriefInput" name="olderAttempts" id="olderAttempts"
                use:text_area_resize
                />

                <label for="olderAttemptResults">What happened? Were they successful but forgotten? Or were they a failure? Why?</label>
                <textarea disabled={readOnlyMode} bind:value={research.curiosityCorruption.olderAttemptResults} rows="3" class="shortBriefInput" name="olderAttemptResults" id="olderAttemptResults"
                use:text_area_resize
                />
            </div>
            {/if}
        </div>
        <div class="textAreaDiv">
            <label for="painPointBelief">Is there a belief that the market’s Pain Point used to not exist, or used to not be so bad? (List these beliefs out)</label>
            <textarea disabled={readOnlyMode}
            bind:value={research.curiosityCorruption.painPointBelief}
             rows="2" class="shortBriefInput" name="painPointBelief" id="painPointBelief"
             use:text_area_resize
             />
            
            <label for="outsideForcesBelief">Is there a belief that it’s been recently exacerbated by outside forces?</label>
            <input name="outsideForcesBeliefBoolean"
            on:click={() => recentlyChecked = 'outsideForcesReason'}
            bind:checked={research.curiosityCorruption.outsideForcesBeliefBoolean}
             class="w-6 h-6 pl-6 ring-2 ring-offset-blue-400" type="checkbox"
            
            /><span class="h-6 pl-3" style="vertical-align:super;">Yes.</span>
            {#if research.curiosityCorruption.outsideForcesBeliefBoolean}
            <div transition:slide|local>
                <label for="outsideForcesReason">If so, what are those forces and what’s the reason behind their presence?</label>
                <textarea disabled={readOnlyMode}
                bind:value={research.curiosityCorruption.outsideForcesReason}
                 rows="3" class="shortBriefInput" name="outsideForcesReason" id="outsideForcesReason"
                 use:text_area_resize
                 />
            </div>
            {/if}
        </div>
    </div>
    {/if}
    <h1
    on:click={(evt)=> {
        evt.preventDefault()
        research.displaySettings.showExtraNotes = !research.displaySettings.showExtraNotes}}
     class="researchSectionHeading
     border-t-2
     border-black
       border-dotted
     ">Extra Notes: 
        <button class="
    
        accordionButton 
        {research.displaySettings.showExtraNotes?"bg-red-500" : "bg-third"}">{#if research.displaySettings.showExtraNotes
            } - {:else} + {/if}</button>
    </h1>
    {#if research.displaySettings.showExtraNotes}
        <div transition:slide|local class="extraNotesDiv textAreaDiv pt-4">
            <textarea disabled={readOnlyMode}
            bind:value={research.extraNotes}
            placeholder="Stories, interesting comments or reviews, extra thoughts and ideas..."
            rows="20" 
            class="shortBriefInput" 
            name="extraNotes" 
            id="extraNotes"/>
        </div>
    {/if}
    </form>
    </div>
</div>
<svelte:head>
    <!-- <link href="//cdn.quilljs.com/1.3.6/quill.snow.css" rel="stylesheet"> -->
</svelte:head>
<style>
    /* @import 'https://cdn.quilljs.com/1.3.6/quill.snow.css'; */
    /* .textAreaDiv {
        max-width: fit-content;
    } */
        .editingContainer{
            width: 50vw;
            max-width: 50vw;
            height: 83vh;
            display: flex;
            flex-direction: row;
            /* position: absolute; */
            top:0;
            bottom: 0;
            left: 0;
            right: 0;
        }
        label{
            /* font-weight:bold; */
            @apply mt-4;
            display: block;
            max-width: 95%;
        }

        .editorContainer{
            flex: 1;
            width: 50%;
            max-height: 83vh;
            overflow-y: scroll;
            /* border: black solid 1px; */
        }
        .ql-editor{
            overflow-y:scroll;
        }
        .tabContainer{
            display: flex;
            flex-direction: row;
        }
        .tab{
            cursor: pointer;
            padding-left: 10px;
            padding-right: 10px;
        }

        .active {
            border: black 1px solid;
            border-radius: 5px 5px 0px 0px;
        }
        .inactive{
            color: rgba(255, 255, 255, 0.657);
            background-color: peachpuff;
        }
        .editor{
            /* border: black 1px solid; */
            font-family: monospace;
            font-size: x-large;
        }
        .shortBriefInput{
            width: 90%;
            background-color: rgba(255, 255, 255, 1);
            @apply border-black;
            @apply rounded;
            @apply border-2;
            display: block;
        }
        .researchSectionHeading {
            @apply text-2xl cursor-pointer pt-2 pb-2 border-b border-dotted border-gray-400;
        }
    
        .activeEditor{
            height:100%;
        }
    
        .inactiveEditor{
            display: none;
        }

        .accordionButton {
            @apply text-2xl text-white rounded-full w-8 h-8 float-right mr-20 outline-none focus:outline-none hover:bg-secondary;
        }

</style>